export default "__VITE_ASSET__BkBz3Bn3__"